import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChange,
} from '@angular/core';
import { head, tail } from 'lodash';
import { BTN_COLLAPSE, BTN_SHOW_ALL } from '@text-content/button-templates/';
import { DEFAULT_FORM_UPDATE_DELAY_MS } from '@config/global-constants';
import { Observable, observableTimer, rx, Subject } from '@shared/rx';

@Component({
  selector: 'xvi-alert-box',
  templateUrl: 'alert-box.component.html',
  styleUrls: ['alert-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XVIAlertBoxComponent implements OnChanges, OnInit {
  @Input() public errors: object[] = [];
  public isSpoilerCollapsed: boolean = true;
  public firstError: object;
  public hiddenErrors: object[] = [];
  public buttonCaption: string = BTN_SHOW_ALL.caption as string;

  public animate$: Observable<boolean>;
  public animationTrigger$: Subject<void> = new Subject<void>();

  public ngOnChanges(
    changes: Record<keyof XVIAlertBoxComponent, SimpleChange>,
  ): void {
    if (changes.errors) {
      const currentValue = changes.errors.currentValue ?? [];
      const previousValue = changes.errors.previousValue ?? [];
      if (currentValue > previousValue) this.animationTrigger$.next();
    }

    this.firstError = head(this.errors);
    this.hiddenErrors = tail(this.errors);
  }

  public ngOnInit(): void {
    this.animate$ = this.animationTrigger$.pipe(
      rx.switchMap(() =>
        observableTimer(DEFAULT_FORM_UPDATE_DELAY_MS).pipe(
          rx.mapTo(false),
          rx.startWith(true),
        ),
      ),
      rx.startWith(false),
    );
  }

  public toggleButtonCaption(): void {
    this.buttonCaption = (
      this.isSpoilerCollapsed ? BTN_COLLAPSE.caption : BTN_SHOW_ALL.caption
    ) as string;
    this.isSpoilerCollapsed = !this.isSpoilerCollapsed;
  }
}
